import _extends from "@babel/runtime/helpers/esm/extends";
import { colors } from '../../tokens';
var defaultStyles = {
  dropdownIndicator: {
    color: colors.brand.primary
  },
  clearIndicatorStyles: {
    cursor: 'pointer',
    padding: '0px 8px'
  },
  multiValueStyles: {
    backgroundColor: colors.brand.primary,
    marginTop: '0px',
    marginLeft: '0px',
    height: '30px',
    borderRadius: '4px',
    padding: '8px 8px 8px 16px',
    display: 'flex',
    alignItems: 'center'
  },
  multiValueLabelStyles: {
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: colors.white,
    padding: '0px',
    paddingLeft: '0px',
    display: 'flex',
    alignItems: 'center'
  },
  multiValueRemoveStyles: {
    cursor: 'pointer',
    marginLeft: '8px',
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    backgroundColor: colors.grey[300],
    color: colors.white,
    ':hover': {
      color: colors.white
    },
    '& svg': {
      transform: 'scale(1.7)'
    }
  }
};
export default {
  "default": defaultStyles,
  error: _extends({}, defaultStyles, {
    dropdownIndicator: {
      color: colors.error
    }
  })
};